import { createStructuredSelector } from 'reselect';
import { selectIsUpdatingUser, selectUserPersonalInformation, selectUserLanguage } from 'ducks/loggedInUser/selectors';

export default createStructuredSelector({
  isUpdatingUser: selectIsUpdatingUser,
  userPersonalInformation: selectUserPersonalInformation,
  userLanguage: selectUserLanguage,
});
